import { ReactNode, RefObject } from 'react';
import { FormattedMessage } from 'react-intl';

import ActionIconButton from '@components/buttons/ActionIconButton';
import styles from '@components/layout/Section.module.css';
import BodyCopy from '@components/typography/BodyCopy';
import BodyCopyBold from '@components/typography/BodyCopyBold';
import Heading1 from '@components/typography/Heading1';
import Heading2 from '@components/typography/Heading2';

type Props = {
  children: ReactNode;
  descriptionKey?: string;
  icon?: ReactNode;
  mediumTitle?: boolean;
  onEdit?: () => void;
  scrollRef?: RefObject<HTMLDivElement>;
  smallSpacing?: boolean;
  smallTitle?: boolean;
  titleKey: string;
  titleValues?: Record<string | number, ReactNode>;
};

const EditableSection = ({
  children,
  descriptionKey,
  icon,
  mediumTitle = true,
  onEdit,
  scrollRef,
  smallSpacing = false,
  smallTitle = false,
  titleKey,
  titleValues
}: Props) => (
  <div className={styles.editableSection} ref={scrollRef}>
    <div className={smallSpacing ? styles.editableHeaderSmall : styles.editableHeader}>
      <div className={styles.title}>
        <div className={`${styles.topRow} ${descriptionKey ? '' : styles.noMargin}`}>
          {icon}
          {smallTitle ? (
            <BodyCopyBold color="primary700">
              <FormattedMessage id={titleKey} values={titleValues} />
            </BodyCopyBold>
          ) : mediumTitle ? (
            <Heading2>
              <FormattedMessage id={titleKey} values={titleValues} />
            </Heading2>
          ) : (
            <Heading1>
              <FormattedMessage id={titleKey} values={titleValues} />
            </Heading1>
          )}

          {onEdit && (
            <div className={styles.editIcon}>
              <ActionIconButton ariaLabelKey="accessibility.ariaLabels.edit" icon="edit" onClick={onEdit} />
            </div>
          )}
        </div>
      </div>

      {descriptionKey && (
        <div>
          <BodyCopy color="neutral500">
            <FormattedMessage id={descriptionKey} />
          </BodyCopy>
        </div>
      )}
    </div>
    {children}
  </div>
);

export default EditableSection;
